import { useContext, useEffect, useState } from 'react';
import { PaymentMethodEnum } from '@/types/common';
import { CheckoutContext } from '@/context/CheckoutContext';
import { isMobileDevice } from '@/utils/device';

export const useApplicationState = () => {
  const context = useContext(CheckoutContext);
  const [lastPaymentMethodSelected, setLastPaymentMethodSelected] = useState<PaymentMethodEnum | undefined>(undefined);

  useEffect(() => {
    if (!context || isMobileDevice()) return;

    if (lastPaymentMethodSelected !== undefined && lastPaymentMethodSelected !== context.paymentMethodSelected) {
      context.viewer.setViewer(undefined);
    }
    setLastPaymentMethodSelected(context.paymentMethodSelected);
  }, [context?.paymentMethodSelected, lastPaymentMethodSelected, context]);
};
